import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, matchPath, NavLink } from 'react-router-dom';
import { getDimmedTextColor } from 'utils/ui';
import Box from 'components/Box';
import Button from 'components/Button';
import DotIcon from 'components/icons/lib/Dot';
import Flex from 'components/Flex';
import Hidden from 'components/Hidden';
import MatchTextWidth from 'components/MatchTextWidth';
import Status from 'components/Status';
import TooltipButton from 'components/TooltipButton';
import useBreakpoints from 'hooks/useBreakpoints';
function EditorSaveStatus(_ref) {
  var noUnsavedChangesText = _ref.noUnsavedChangesText,
    hasUnsavedChanges = _ref.hasUnsavedChanges,
    isSaving = _ref.isSaving,
    onSave = _ref.onSave,
    stateOptions = _ref.stateOptions,
    previewOptions = _ref.previewOptions,
    _ref$canSaveChanges = _ref.canSaveChanges,
    canSaveChanges = _ref$canSaveChanges === void 0 ? true : _ref$canSaveChanges,
    tooltipTitle = _ref.tooltipTitle,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'right' : _ref$justifyContent,
    breakpoints = _ref.breakpoints;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var isSaveDisabled = !hasUnsavedChanges || !canSaveChanges;
  var _useBreakpoints = useBreakpoints(['xxs', 's']),
    xxs = _useBreakpoints.xxs,
    s = _useBreakpoints.s;
  var statusText = hasUnsavedChanges ? t('state_unsaved_changes') : noUnsavedChangesText || t('state_no_changes_since_your_last_edit');
  var previewLink = '';
  var isPreviewActive = false;
  if (previewOptions) {
    isPreviewActive = !!matchPath(location.pathname, {
      path: previewOptions.previewLocation,
      exact: true
    });
    previewLink = isPreviewActive ? previewOptions.exitLocation : previewOptions.previewLocation;
  }
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "m",
    fontSize: "s",
    justifyContent: justifyContent,
    breakpoints: breakpoints
  }, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    textAlign: "right",
    py: "xxs"
  }, /*#__PURE__*/React.createElement(Flex, {
    shrink: true,
    gap: "xs"
  }, /*#__PURE__*/React.createElement(Status, {
    shrink: true,
    as: "span",
    mr: stateOptions ? [undefined, 's'] : undefined,
    breakpoints: "s",
    overflow: "ellipsis"
  }, /*#__PURE__*/React.createElement(Hidden, {
    below: "xs",
    accessible: true,
    as: "span"
  }, hasUnsavedChanges && /*#__PURE__*/React.createElement(DotIcon, {
    vAlign: true,
    color: "highlight",
    mr: ""
  }), statusText), /*#__PURE__*/React.createElement(Hidden, {
    above: "xs",
    as: "span"
  }, /*#__PURE__*/React.createElement(DotIcon, {
    dimmed: !hasUnsavedChanges,
    color: hasUnsavedChanges ? 'highlight' : getDimmedTextColor,
    mr: "xxs"
  }))), stateOptions)), /*#__PURE__*/React.createElement(Flex, {
    shrink: true,
    gap: "s"
  }, previewOptions && /*#__PURE__*/React.createElement(Button, {
    as: NavLink,
    to: previewLink,
    isActive: isPreviewActive,
    icon: isPreviewActive ? 'eye-closed' : 'eye-open',
    iconOnly: !s
  }, /*#__PURE__*/React.createElement(MatchTextWidth, {
    alternativeText: t('actions_exit_preview'),
    showAlternativeText: isPreviewActive
  }, t('actions_preview'))), /*#__PURE__*/React.createElement(TooltipButton, {
    title: tooltipTitle,
    variant: "primary",
    icon: "ok",
    iconOnly: !xxs,
    onClick: onSave,
    isLoading: isSaving,
    isDisabled: isSaveDisabled
  }, t('actions_save_changes'))));
}
export default EditorSaveStatus;